// import { eventBus, EVENTS } from './EventBus.js';
const INITIAL_POS = 0;
const TOLERANCE = 50;
let handling = false;
let data = {
  xPos: INITIAL_POS,
  partialXPos: INITIAL_POS,
  yPos: INITIAL_POS,
  partialYPos: INITIAL_POS,
  removed: false,
  ended: false
};
let root = document.documentElement;
let lastBreakpoint;
const DIRECTIONS = {
  LEFT: { touchClient: 'clientX', checkHandleCondition: diff => diff < 0, pos: 'xPos', partialPos: 'partialXPos', name: 'left' },
  RIGHT: {
    touchClient: 'clientX',
    checkHandleCondition: diff => diff > 0,
    pos: 'xPos',
    partialPos: 'partialXPos',
    name: 'right'
  }
  // TOP: { touchClient: 'clientY', checkHandleCondition: diff => diff < 0, pos: 'yPos', partialPos: 'partialYPos', name: 'top' },
  // BOTTOM: { touchClient: 'clientY', checkHandleCondition: diff => diff > 0, pos: 'yPos', partialPos: 'partialYPos', name: 'bottom' }
};

class Paginator {

  constructor(container, { pages, perPage, total, cssVar, breakpoints, swipeElementSelector }){
    this.container=container;
    this.pages=pages;
    this.perPage=perPage;
    this.total=total;
    this.cssVar=cssVar;
    this.breakpoints=breakpoints;
    this.swipeElementSelector=swipeElementSelector;
    this.init(null,{});
    if(this.breakpoints){
      this.onresize=()=>{
        let idx=this.calcBreakpointIdx();
        if(idx!=lastBreakpoint){
          this.init(idx,{});
        }
      };
      $( window ).resize(this.onresize);
    }
  }



  init(breakpointIdx, {pages, perPage, total, cssVar, breakpoints}) {

    if(pages)  this.pages = pages;
    if(perPage)  this.perPage = perPage;
    if(total)  this.total = total;
    if(cssVar)  this.cssVar = cssVar;
    if(breakpoints)  this.breakpoints = breakpoints;

    let breakpoint;
    breakpointIdx = breakpointIdx || this.calcBreakpointIdx();
    if(breakpointIdx>-1){
      breakpoint=this.breakpoints[breakpointIdx];
    }
    this.lastBreakpoint=breakpointIdx;

    if(breakpoint && breakpoint.perPage && this.total){
      this.pages = Math.ceil(this.total / breakpoint.perPage);
    }else if(this.total && this.perPage){
      this.pages = Math.ceil(this.total / this.perPage);
    }else if(!this.pages){
      throw new Error('wrong configuration')
    }
    if($(this.container).find('.h-list').length){
      $(this.container).find('.h-list').remove();
      $(this.container).find('.paginator-index').remove();
    }
    let template = `<ul class="h-list">`;

      if(this.pages >=3){
          for (let i = 0; i < this.pages; i++) {
              let selected = i === 0 ? 'selected' : '';
              let hidden = i >= 2 ? 'hidden_paginator' : '';
              template += `<li data-idx="${i + 1}" class="paginator ${selected} ${hidden}"></li>`
          }
      }else{
          for (let i = 0; i < this.pages; i++) {
              let selected = i === 0 ? 'selected' : '';
              template += `<li data-idx="${i + 1}" class="paginator ${selected}"></li>`
          }
      }




    template += `</ul>
    <div class="paginator-index"><span>1/${this.pages}</span></div>
    `;

    if(this.pages != 1){
            this.container.append(template);
    }
    try {
      this.addListeners();
    } catch (error) {
      $( window ).off('resize', this.onresize);
    }
  }

  calcBreakpointIdx() {
    let breakpointIdx;
    if(this.breakpoints){
      breakpointIdx=this.breakpoints.findIndex((breakpoint)=>{
        const maxWidth=breakpoint.maxWidth||9999;
        const minWidth=breakpoint.minWidth||0;
        const curWidth=window.innerWidth;
        if(curWidth<=maxWidth && curWidth>=minWidth){
          return breakpoint;
        }
      });
    }
    return breakpointIdx;
  }

  addListeners() {
    $(this.container).find('.paginator').on('click', (e) => {

      var idx = parseInt(e.target.dataset.idx);
      if(e.target.nextSibling){
        e.target.nextSibling.classList.remove("hidden_paginator");
      }
      if(e.target.previousElementSibling){
        e.target.previousElementSibling.classList.remove("hidden_paginator");
      }


      var prev_to_hide = idx - 2;
      var next_to_hide = idx + 2;
      if(idx != $(this.container).find(".paginator").length ){
        $(this.container).find(".paginator[data-idx="+prev_to_hide+"]").addClass("hidden_paginator");
      }
      $(this.container).find(".paginator[data-idx="+next_to_hide+"]").addClass("hidden_paginator");

      $(this.container).find('.paginator').removeClass('selected');
      $(e.currentTarget).addClass('selected')
      const index = $(e.currentTarget).attr('data-idx');
      $(this.container).find('.paginator-index span').text(`${index}/${this.pages}`);
      if (this.cssVar) {
        root.style.setProperty(this.cssVar, (index - 1));
      }
    });

    if(this.swipeElementSelector){
      const el = document.querySelector(this.swipeElementSelector);
      el.addEventListener('touchstart', (e) => {
         this.handleStart(e);
         }, { passive: true});
      el.addEventListener('touchend', (e) => { this.handleEnd(e); }, { passive: true});
      el.addEventListener('touchcancel', (e) => { this.handleCancel(e); }, { passive: true});
      el.addEventListener('touchmove', (e) => { this.handleMove(e); }, { passive: true});
    }
  }

  handleStart(evt) {
    console.log('handleStart');

    const touches = evt.changedTouches;
    data.xPos = touches[0].clientX;
    data.yPos = touches[0].clientY;
    data.partialXPos = 0;
    data.partialYPos = 0;
  }

  handleCancel(evt) {
    evt.preventDefault();
  }

  handleMove(evt) {
    console.log('handle move');

    const element = evt.currentTarget;
    const touches = evt.changedTouches;
    const diffY = touches[0].clientY - data.yPos;
    const diffX = touches[0].clientX - data.xPos;
    let horizontalScroll = true;
    if (Math.abs(diffY) > Math.abs(diffX)) {
      horizontalScroll = false;
    }

    console.log('horizontalScroll:',horizontalScroll);

    for (const key in DIRECTIONS) {
      const direction = DIRECTIONS[key];
      let diff = touches[0][direction.touchClient] - data[direction.pos];
     if (!horizontalScroll) {
        return;
      }
      evt.preventDefault();
      console.log('direction.checkHandleCondition(diff):',direction.checkHandleCondition(diff));
      console.log('diff',diff);

      if (direction.checkHandleCondition(diff) && Math.abs(diff) >= TOLERANCE) {
        data[direction.pos] = touches[0][direction.touchClient];
        if(direction.name==='left'){

            $(this.container).find('.paginator.selected').next().click();
        }else{
            $(this.container).find('.paginator.selected').prev().click();
        }
        root.style.setProperty('--swipe-diff-h', `0px`);
        root.style.setProperty('--swipe-diff-percentage-h', `0`);

      } else if (direction.checkHandleCondition(diff) && Math.abs(diff) < TOLERANCE) {
        diff = diff - data[direction.partialPos];
        root.style.setProperty('--swipe-diff-h', `${diff}px`);
        root.style.setProperty('--swipe-diff-percentage-h', `${diff / 100}`);
      }
    }
  }

  handleEnd(evt) {
    // console.log('handleEnd');
    if (handling) {
      return;
    }
    const element = evt.currentTarget;
    // ADD CLASS
    // if (!config.removed) {
    //   element.style.transform = `translate3d(0, 0, 0)`;
    // }

    root.style.setProperty('--swipe-diff-h', '0px');
    root.style.setProperty('--swipe-diff-percentage-h', '0');
    // if (!data.removed) {
    //   element.style.transform = `translate3d(0, 0, 0)`;
    // }
    data.xPos = 0;
    data.yPos = 0;
  }

  reset(){
      // let root = document.documentElement;
      root.style.setProperty(this.cssVar, 0);
      $(this.container).find('.paginator-index span').text(`1/${this.pages}`);
      $(this.container).find('.paginator').removeClass('selected');
      $($(this.container).find('.paginator')[0]).addClass('selected');
  }

}
export {Paginator};
